import React from 'react'
import { ReactComponent as OpenModalIcon } from 'shared/components/Icons/open-modal-icon.svg'
import styled from 'shared/theme'
import { useButton } from '@react-aria/button'

export default OpenModalIcon

type OpenModalIconButtonProps = Omit<React.HTMLProps<HTMLButtonElement>, 'children'>
const OpenModalIconButtonElement = styled(OpenModalIcon)<OpenModalIconButtonProps>`
    cursor: pointer;
    color: ${props => props.theme.colors.textSecondary};
`

export function OpenModalButton(props: OpenModalIconButtonProps): JSX.Element {
    const ref = React.useRef<HTMLButtonElement>()
    const { buttonProps } = useButton({ elementType: 'svg' }, ref as any)
    return <OpenModalIconButtonElement {...buttonProps} {...(props as any)} />
}
